import {Subject} from 'rxjs';

/**
 * Selects the best rear camera, avoiding wide-angle/fisheye lenses.
 *
 * - 2 cameras: facingMode: 'environment' handles it (no switch needed)
 * - 3+ cameras: finds rear camera without "wide/ultra" in label
 * - Falls back to last camera in list (wide-angle is usually listed first)
 * - User can always switch manually via ngx-webcam's built-in button
 */
export function selectBestCamera(devices: MediaDeviceInfo[], switchCamera$: Subject<boolean | string>): void {
	if (devices.length <= 2) return;

	const wideKeywords = ['wide', 'ultra', 'gran angular', 'wide-angle'];
	const nonWideRear = devices.find(d =>
		d.label &&
		!wideKeywords.some(kw => d.label.toLowerCase().includes(kw)) &&
		(d.label.toLowerCase().includes('back') || d.label.toLowerCase().includes('rear') || d.label.toLowerCase().includes('trasera'))
	);

	if (nonWideRear) {
		switchCamera$.next(nonWideRear.deviceId);
		return;
	}

	switchCamera$.next(devices[devices.length - 1].deviceId);
}
